const prefixed = name => `navigation/${name}`;

export const NAVIGATE = prefixed("NAVIGATE");
export const REPLACE = prefixed("REPLACE");
export const BACK = prefixed("BACK");

export const NAVIGATED = prefixed("NAVIGATED");

export const NEW_META = prefixed("NEW_META");
